export default "__VITE_ASSET__C_Q7YWQe__"